<template>
  <span :class="classes()">
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'Label',
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primaryCoralLightest',
      validator: (val) =>
        [
          'primaryCoralLightest',
          'secondaryRoseLight',
          'secondaryYellow',
          'supportSuccess',
          'supportInfo',
        ].includes(val),
    },
    size: {
      type: String,
      default: 's',
      validator: (val) => ['s', 'm'].includes(val),
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      el: 'o-label',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.color}`]: true,
          [`${el}--${this.size}`]: this.size,
          [`${el}--bold`]: this.bold,
        };
      },
    };
  },
};
</script>
